// extracted by mini-css-extract-plugin
module.exports = {"buildAppNavigation":"BuildAppNavigation_buildAppNavigation__AYmUw","list":"BuildAppNavigation_list__NlzVq"};